// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

export const StyledTermText = styled.div`
  font-size: ${(props) => props.theme.fontSizes.small.fontSize};
  line-height: 1.5;

  & {
    .term-title {
      margin-top: 1.5rem;
      font-weight: bold;

      &:first-child {
        margin-top: 0;
      }
    }

    .term-list {
      padding: 0 0 0 2rem;
      list-style-type: decimal;
    }

    .term-list-item {
      margin-top: 0.5rem;

      &:first-child {
        list-style: none;
      }
    }

    .term-sub-list {
      padding: 0 0 0 1rem;
      counter-reset: cnt;
    }

    .term-sub-list-item {
      margin-top: 0.5rem;
      padding-left: 1rem;
      text-indent: -1rem;

      &::before {
        counter-increment: cnt;
        content: '(' counter(cnt) ') ';
      }
    }
  }
`;

export const StyledTermTextForUser = styled(StyledTermText)`
  & {
    .term-list-item {
      &:first-child {
        list-style: inherit;
      }

      &:only-child {
        list-style: none;
      }
    }
  }
`;
